/**
 *  ThemeLoaderScene
 *
 *  Created by Legman on 08/05/2017.
 *
 */

import Common from "../Common";

export default class ThemeLoaderScene extends p3.Scene {
    constructor() {
        super();

        const assets = Common.assets;
        const bg = new PIXI.Sprite(assets.getTexture("ui_loading"));
        this.addChild(bg);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._wheel = new PIXI.Sprite(assets.getTexture("ui_loader"));
        this._wheel.x = Common.STAGE_WIDTH * 0.5;
        this._wheel.y = p3.View.height * 0.5;
        this._wheel.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._wheel);

        if (language === "ar") {
            this._loadingLabel = new PIXI.Text(translate("theme_loader"), {
                fontSize: "54px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6});
            this._loadingLabel.x = Common.STAGE_WIDTH * 0.5;
            this._loadingLabel.y = p3.View.height * 0.5 + 240;
            this._loadingLabel.pivot.x = this._loadingLabel.width * 0.5;
            this._loadingLabel.pivot.y = this._loadingLabel.height * 0.5;
            this.addChild(this._loadingLabel);
        } else {
            this._loadingLabel = new PIXI.BitmapText(translate("theme_loader"), font(64, "center"));
            this._loadingLabel.x = Common.STAGE_WIDTH * 0.5;
            this._loadingLabel.y = p3.View.height * 0.5 + 240;
            this._loadingLabel.pivot.x = this._loadingLabel.textWidth * 0.5;
            this._loadingLabel.pivot.y = this._loadingLabel.textHeight * 0.5;
            this.addChild(this._loadingLabel);
        }
    }

    appear() {
        super.appear();

        const assets = Common.assets;
        assets.unloadTexture("track");
        assets.unloadTexture("skybox");

        // todo switch random tracks back on
        const random = Math.floor(Math.random() * 5);
        let files = [];

        switch (random) {
            case 0 : {
                files = [
                    {name: "track", url: "images/" + "wr1_mountain_1x" + ".json"},
                    {name: "skybox", url: "images/" + "wr1_mountain_bg_1x" + ".png"}
                ];
                break;
            }
            case 1 : {
                files = [
                    {name: "track", url: "images/" + "wr2_snow_1x" + ".json"},
                    {name: "skybox", url: "images/" + "wr2_snow_bg_1x" + ".png"}
                ];
                break;
            }
            case 2 : {
                files = [
                    {name: "track", url: "images/" + "wr3_halloween_1x" + ".json"},
                    {name: "skybox", url: "images/" + "wr3_halloween_bg_1x" + ".png"}
                ];
                break;
            }
            case 3 : {
                files = [
                    {name: "track", url: "images/" + "wr4_desert_1x" + ".json"},
                    {name: "skybox", url: "images/" + "wr4_desert_bg_1x" + ".png"}
                ];
                break;
            }
            case 4 : {
                files = [
                    {name: "track", url: "images/" + "wr5_italy_1x" + ".json"},
                    {name: "skybox", url: "images/" + "wr5_italy_bg_1x" + ".png"}
                ];
                break;
            }
        }

        assets.addFiles(files, "assets/");
        assets.signals.progress.add(this.onLoadingProgress, this);
        assets.signals.complete.addOnce(this.onLoadingCompleted, this);
        assets.load();
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {
        this._wheel.rotation += 8 * deltaTime;
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        console.log("progress:", event.progress + "%");
    }

    onLoadingCompleted() {
        const assets = Common.assets;
        assets.signals.progress.removeAll();
        assets.signals.complete.removeAll();

        this.signals.next.dispatch(this);
    }
}